import React from 'react';
import { styled } from '../../../theme/styled';
import { ACTION_BUTTON_INNER_SPACING } from '../const';
import { ActionButtonOwnerState } from '../model';

export const ActionButtonRoot = styled('button', {
  name: 'ActionButton',
  slot: 'Root',
})<{ ownerState: ActionButtonOwnerState }>(({ theme, ownerState }) => {
  const commonStyles: React.CSSProperties = {
    color: theme.palette['brand gray'],
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderStyle: 'none',
    borderColor: 'transparent',
  };

  return {
    ...commonStyles,
    ...theme.typography.button,
    position: 'relative',
    display: 'inline-flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: ownerState.disabled ? 'not-allowed' : 'pointer',
    userSelect: ownerState.disabled ? 'none' : 'auto',
    transition: theme.transitions.create(['color'], {
      duration: theme.transitions.duration.short,
    }),
    WebkitTapHighlightColor: 'transparent',
    padding: theme.spacing(ACTION_BUTTON_INNER_SPACING),

    '& > *': {
      color: 'inherit !important',
    },

    '&:focus, &:active': {
      outline: 'none',
    },

    '@media (pointer: fine)': {
      '&:hover': !ownerState.disabled && {
        color: theme.palette['brand pink'],
      },
    },
  };
});
